<template>
 <div id="information-all-view">
   <div class="informationbanner">
     <div class="img-content">
       <div class="title-content">
          <h2 class="title">信息披露</h2>
          <p>“一群很轴的书生”在透明公示，您放心使用</p>
       </div>
     </div>
   </div>
   <div class="infor-content clearfix">
     <side-navigation></side-navigation>
      <router-view/>
   </div>
 </div>
</template>

<script>
import sideNavigation from '@/components/sideNavigation'
export default {
  data () {
    return {

    }
  },
  components: {
    sideNavigation
  }
}
</script>

<style lang="less">
#information-all-view{
  background: #f5f5f5;
  .informationbanner{
    width: 100%;
    height: 160px;
    margin-bottom: 20px;
    .img-content{
      height:160px;
      background: url(../../assets/images/information-banner.png) no-repeat center 0;
      position: relative;
      .title-content{
        width: 100%;
        text-align: center;
        position: absolute;
        top: 40px;
        z-index: 100;
        h2{
          font-size: 30px;
          font-weight: bold;
          letter-spacing: 1px;
          color: #fff;
          margin-bottom:10px;
        }
        p{
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
  .infor-content{
    width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/informationAll.vue